import { useTreeStore } from "@/frontend/store/TreeStore";
import { ContainerTreeObject } from "@/frontend/types/navigationTypes";
import { I18n } from "@/i18n/I18n";
import { ParameterType, ParameterSubjectType } from "@/types/parameterTypes";
import { ParameterRun } from "../parameters/ParameterRun";
import { ScenarioRun } from "./ScenarioRun";
import { Step } from "@/backend/models/containers/step";
import { Form } from "react-bootstrap";
import { StepStatusButtons } from "./StepStatusButtons";
import { useStepIsDisabled } from "@/frontend/hooks/useStepIsDisabled";
import { StepValidationsSummary } from "../validations/StepValidationsSummary";
import { useIsSnippetPreview } from "./SnippetPreviewContext";

export function StepItemRunBody(props: { step: ContainerTreeObject, onUpdateStatus: () => void }) {
  const { step, onUpdateStatus } = props;
  const updateContainer = useTreeStore((state) => state.updateContainer);
  const isSnippetPreview = useIsSnippetPreview();

  const scenarios = step.children.filter((child) => child.container.isScenario());
  const selectedScenario = scenarios.find((scenario) => scenario.container.id === (step.container as Step)?.selectedScenarioId) || scenarios[0];

  const { disabled, disableMessage } = useStepIsDisabled(step.id);

  return (
    <>
      <div className="card-body" hidden={false}>
        { step.container.description && <p style={{whiteSpace: 'pre-wrap'}} className='pb-3'>{step.container.description}</p> }
        <div className='pb-3'><ParameterRun id={step.id} parameterType={ParameterType.INPUT } parentType={ParameterSubjectType.STEP} /></div>
        <div className="">
          { (disabled && disableMessage) &&
            <div className='alert alert-warning text-center'>{disableMessage}</div>
          }
          <div className="d-flex flex-column gap-3">
            { selectedScenario && <div id={selectedScenario.container.id} className="card observed-element">
              { scenarios.length > 1 && (
                <div className="card-header">
                  <div className="d-flex pt-1 justify-content-between">
                    <div className="d-flex w-40  align-items-center">
                      <Form.Select aria-label={I18n.get('selectScenario')} value={selectedScenario.id} onChange={(event) => { void updateContainer({ container: { ...step.container, selectedScenarioId: event.target.value }}); }}>
                        {scenarios.map((scenario) => <option key={scenario.id} value={scenario.id}>{scenario.container.title}</option>)}
                      </Form.Select>
                    </div>
                  </div>
                </div>
              )}
              <ScenarioRun scenarioNode={selectedScenario} />
            </div> }
          </div>
        </div>
        <StepValidationsSummary stepId={step.id} />
        <div className='pt-3'><ParameterRun id={step.id} parameterType={ParameterType.OUTPUT} parentType={ParameterSubjectType.STEP} /></div>
      </div>
      { /* A snippet preview renders authoring containers, so it must not persist step status */ }
      { !isSnippetPreview && <div className="card-footer d-flex justify-content-end">
        {step.container instanceof Step && (
          <StepStatusButtons
            step={step.container}
            onUpdateStatus={onUpdateStatus}
          />
        )}
      </div> }
    </>
  );
}
